<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle"><a id="con"></a>CONTENTS</h1>
<p class="toc"><a href="#/06_preface#pre">Preface</a></p>
<p class="toc"><a href="#/07_introduction#intro">Introduction</a></p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="toc"><a href="#/09_chapter01#c1">1. The Enchanted World</a></p>
<p class="toc"><span href="#/10_chapter02#c2" title="Link target outside of Sample">2. The Rose and Thorn Path</span></p>
<p class="toc"><span href="#/11_chapter03#c3" title="Link target outside of Sample">3. Tools of the Witches' Craft</span></p>
<p class="toc"><span href="#/12_chapter04#c4" title="Link target outside of Sample">4. Plant Spirits of the Greenwood</span></p>
<p class="toc"><span href="#/13_chapter05#c5" title="Link target outside of Sample">5. Works of Magic</span></p>
<p class="toc"><span href="#/14_chapter06#c6" title="Link target outside of Sample">6. The Old Ones</span></p>
<p class="toc"><span href="#/15_chapter07#c7" title="Link target outside of Sample">7. The Mythos</span></p>
<p class="toc"><span href="#/16_chapter08#c8" title="Link target outside of Sample">8. The Old Rites</span></p>
<p class="toc"><span href="#/17_chapter09#c9" title="Link target outside of Sample">9. The Modern Solitary Rites</span></p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="toc"><span href="#/18_appendixa#appa" title="Link target outside of Sample">Appendix A: The Plant Spirit Seals</span></p>
<p class="toc"><span href="#/19_appendixb#appb" title="Link target outside of Sample">Appendix B: Symbols of the Rose and Thorn Path</span></p>
<p class="toc"><span href="#/20_bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_contents.vue?6d55da1a